import { render, staticRenderFns } from "./DaysoffRequests.vue?vue&type=template&id=47ed3729"
import script from "./DaysoffRequests.vue?vue&type=script&lang=js"
export * from "./DaysoffRequests.vue?vue&type=script&lang=js"
import style0 from "./DaysoffRequests.vue?vue&type=style&index=0&id=47ed3729&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports